import { getUrlParameter } from "./urlParameter";

export const setNewDictionaryToQuery = (serializedData: string) => {
  const currentDictionary = getUrlParameter("dictionary");
  let requestedDictionary = "";
  switch (currentDictionary) {
    case false:
    case "sv":
      requestedDictionary = "en";
      break;
    case "en":
      requestedDictionary = "sv";
      break;
    default:
      requestedDictionary = "sv";
  }
  const indexOfDictionary = serializedData.indexOf("dictionary");
  if (indexOfDictionary !== -1)
    serializedData = serializedData.substring(0, indexOfDictionary - 1);

  serializedData = `${serializedData}&dictionary=${requestedDictionary}`;
  return serializedData;
};
